module.exports = __webpack_public_path__ + "static/media/now_live.32fd8e54.svg";